import React from "react";
import "./index.less";
import ScrollOverPack from "rc-scroll-anim/lib/ScrollOverPack";
import "rc-texty/assets/index.css";
import { OverPack } from "rc-scroll-anim";
import { Col } from "antd";
import QueueAnim from "rc-queue-anim";

export default class content3 extends React.Component {
//   白天、黑夜、阴天 
// 正射影像、倾斜影像、激光点云 
// DOM、DEM、DSM、DLG、 
// 纹理、灰度、反射率、光谱信息 
// 正射、倾斜、激光、 高精度位置信息、高精度姿态信息 
// 影像瑕疵少、点云瑕疵少、大高差 
// 作业时效快、采集效率高
  render() {
    return (
      <ScrollOverPack id="craft" className="allElements-content3">
        <OverPack className="text-content">
          <Col xs={24} sm={24} md={12} lg={12} xl={24}>
            <QueueAnim key="queue" leaveReverse>
              <div className="line"></div>
              <div key="c" className="code-box-shape queue-anim-demo">
                机载200Hz高精度惯导
              </div>
              <div key="c" className="code-box-shape queue-anim-demo">
                <span>融合补偿 , 1+1 大于 2</span>
              </div>
              <div key="c" className="code-box-shape queue-anim-demo">
                旁向重叠率可从70%减小到30%
              </div>
            </QueueAnim>
          </Col>
          <div className="broken-line"></div>
        </OverPack>
        <div className="imag">
          <div className="imag-car">
            <div className="imag1"></div>
            <div className="text">普通倾斜相机测绘航线</div>
          </div>
          <div className="imag-car">
            <div className="imag2"></div>
            <div className="text">RM140测绘航线</div>
          </div>
        </div>
        <OverPack className="text-content">
          <div className="broken-line1"></div>
          <Col xs={24} sm={24} md={12} lg={12} xl={24}>
            <QueueAnim key="queue" leaveReverse>
              <div key="c" className="code-box-shape queue-anim-demo">
                <div className="line"></div>
                <span>相控点极大减少</span>
              </div>
            </QueueAnim>
          </Col>
        </OverPack>
        <div className="imag">
          <div className="imag-car">
            <div className="imag3"></div>
            <div className="text">普通倾斜相机测绘相控点布设</div>
          </div>
          <div className="imag-car">
            <div className="imag4"></div>
            <div className="text">RM140 相控点布设</div>
          </div>
        </div>
        <OverPack className="text-content">
          <Col xs={24} sm={24} md={12} lg={12} xl={24}>
            <QueueAnim key="queue" leaveReverse>
              <div className="line"></div>
              <div key="c" className="code-box-shape queue-anim-demo">
                大型航摄仪的价值体验
              </div>
              <div key="c" className="code-box-shape queue-anim-demo">
                <span>越级的成果表现</span>
              </div>
            </QueueAnim>
          </Col>
        </OverPack>
        <div className="imag">
          <div className="imag-car">
            <div className="imag5"></div>
          </div>
          <div className="imag-car">
            <div className="imag6"></div>
          </div>
        </div>
        <div className="imag">
          <div className="imag-car">
            <div className="imag7"></div>
            <div className="text">表面更平整间隙更清晰</div>
          </div>
          <div className="imag-car">
            <div className="imag8"></div>
            <div className="text">细节元素不遗漏</div>
          </div>
          <div className="imag-car">
            <div className="imag9"></div>
            <div className="text">线条平直，畸变更少</div>
          </div>
        </div>
      </ScrollOverPack>
    );
  }
}
